import React from "react";
import { User, Zap, Building2, Repeat, ArrowRight } from "lucide-react";

const tiers = [
  {
    id: "individual",
    icon: User,
    title: "Individual Clients",
    headline: "Mobile Visit",
    price: "Starting at $99",
    note: "Single-visit pricing for at-home or on-site care.",
  },
  {
    id: "rush",
    icon: Zap,
    title: "Same Day / Rush",
    headline: "Priority dispatch",
    price: "Additional fee may apply",
    note: "Expedited scheduling for urgent same-day requests.",
  },
  {
    id: "facility",
    icon: Building2,
    title: "Providers / Facilities",
    headline: "Volume rates",
    price: "Custom pricing available",
    note: "Contracted pricing for clinics, hospitals, and partners.",
  },
  {
    id: "recurring",
    icon: Repeat,
    title: "Recurring Service",
    headline: "Standing schedule",
    price: "Contact us for monthly scheduling",
    note: "Weekly, biweekly, or monthly visits at preferred rates.",
  },
];

const scrollToForm = () => {
  const el = document.getElementById("request-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const ServicePricing = () => (
  <section
    className="mx-auto max-w-7xl px-5 sm:px-8 py-16 sm:py-20"
    id="pricing"
    data-testid="service-pricing"
  >
    <div className="flex items-baseline gap-4">
      <span
        className="font-display text-xs font-medium tracking-[0.22em]"
        style={{ color: "#D4AF37" }}
      >
        PRICING
      </span>
      <div>
        <h2
          className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight"
          style={{ color: "#0B2545" }}
        >
          Service Pricing
        </h2>
        <p className="mt-2 text-sm sm:text-base" style={{ color: "#475569" }}>
          Transparent, fair pricing for individuals, facilities, and recurring partners.
        </p>
      </div>
    </div>
    <div className="tj-gold-rule mt-6" />

    <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {tiers.map(({ id, icon: Icon, title, headline, price, note }) => (
        <div
          key={id}
          className="rounded-xl border bg-white p-6 transition-all duration-200 hover:-translate-y-[2px]"
          style={{ borderColor: "#E2E8F0" }}
          data-testid={`pricing-card-${id}`}
        >
          <div
            className="grid place-items-center h-10 w-10 rounded-lg"
            style={{ background: "#0B2545" }}
          >
            <Icon className="h-5 w-5" style={{ color: "#D4AF37" }} strokeWidth={2.2} />
          </div>
          <div
            className="mt-5 text-[11px] uppercase tracking-[0.22em] font-medium"
            style={{ color: "#475569" }}
          >
            {title}
          </div>
          <div
            className="mt-2 font-display text-xl font-semibold"
            style={{ color: "#0B2545" }}
          >
            {headline}
          </div>
          <div
            className="mt-3 text-base font-semibold"
            style={{ color: "#D4AF37" }}
          >
            {price}
          </div>
          <p className="mt-3 text-sm leading-relaxed" style={{ color: "#475569" }}>
            {note}
          </p>
        </div>
      ))}
    </div>

    <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <p className="text-xs" style={{ color: "#475569" }}>
        Final pricing confirmed after appointment review. Payment arranged after confirmation.
      </p>
      <button
        type="button"
        onClick={scrollToForm}
        className="inline-flex items-center gap-2 text-sm font-semibold transition-all hover:gap-3"
        style={{ color: "#0B2545" }}
        data-testid="pricing-cta-scroll"
      >
        Request a service
        <ArrowRight className="h-4 w-4" style={{ color: "#D4AF37" }} />
      </button>
    </div>
  </section>
);

export default ServicePricing;
